<app-dialog-base [Title]='"Driver"|translate' [dialogId]="dialogId" (onClose)="close()" (onSubmit)="submit()">
  <div class="inputgroup">
    <label>{{'Full name'|translate}}</label>
    <input type="text" placeholder="" [(ngModel)]="model.Name" />
  </div>
  <div class="inputgroup">
    <label>{{'Internal ID'|translate}}</label>
    <input type="text" placeholder="" [(ngModel)]="model.InternalId" />
  </div>
  <div class="inputgroup">
    <label>{{'Phone №'|translate}}</label>
    <input type="text" [(ngModel)]="model.Phone" />
  </div>
  <div class="inputgroup" *ngIf="containers.length">
    <label>{{'Container'|translate}}</label>
    <input *ngIf="isEditMode" type="text" [value]="getSelectedContainerName()" readonly />
    <select *ngIf="!isEditMode" [(ngModel)]="model.ContainerId">
      <option *ngFor="let container of selectedContainers" [ngValue]="container.Id">{{container.Name}}</option>
    </select>
  </div>
  <div class="inputgroup">
    <label>{{'Driver licence'|translate}}</label>
    <input type="text" placeholder="" [(ngModel)]="model.DriverLicence" />
  </div>
  <div class="inputgroup">
    <label>{{'Valid till'|translate}}</label>
    <calendar [name]="'LicenseValidTill'" [(date)]="model.DriverLicenseTill" [clear]="true"></calendar>
  </div>
  <div class="inputgroup">
    <label>{{'Category'|translate}}</label>
    <input type="text" placeholder="" [(ngModel)]="model.Category" />
  </div>
  <div class="inputgroup">
    <label>{{'Class'|translate}}</label>
    <input type="text" placeholder="" [(ngModel)]="model.Class" />
  </div>

  <div class="inputgroup">
    <label>{{'Insurance'|translate}}</label>
    <input type="text" placeholder="" [(ngModel)]="model.InsuranceID" />
  </div>
  <div class="inputgroup">
    <label>{{'Valid till'|translate}}</label>
    <calendar [name]="'InsuranceValidTill'" [(date)]="model.InsuranceTill" [clear]="true"></calendar>
  </div>
  <app-driver-group-mgmt [model]="model" [groups]="groups" [keys]="keys"></app-driver-group-mgmt>
</app-dialog-base>